import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import './HistoryChange.scss'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
import momentTz from 'moment-timezone'
import moment from 'moment'
import { locale } from '@/root.component'
import { Markup } from 'interweave'

const i18nFields = ['assignment']
const dateFields = ['startDate', 'endDate']
const HistoryChange = (props: { changeFields: any[]; recipientList: any[]; timezone: string }) => {
    const { changeFields, recipientList, timezone } = props

    const componentClass = 'smart-modals-history-change'
    const intl = useIntl()
    const i18nLabelMap = {
        assignment: (value) => {
            return recipientList.find((r) => r.value === (Array.isArray(value) ? value[0] : value))
                ?.label
        },
    }

    const getDate = (date) => {
        return momentTz
            .tz(new Date(date), timezone)
            .format(moment.localeData(locale).longDateFormat('L'))
    }

    return (
        <div className={`${componentClass}__content`}>
            <div className={`${componentClass}__content--current`}>
                <div className={`${componentClass}__item__title`}>
                    {intl.formatMessage({
                        id: `modals.new.activity.history.change.current`,
                        defaultMessage: 'Current',
                    })}
                </div>
                {changeFields &&
                    changeFields.map((field) => (
                        <div className={`${componentClass}__item__field`} key={field.name}>
                            <div className={`${componentClass}__item__field__name`}>
                                {field.message && <span>{field.message}</span>}{' '}
                                <span>{field.name.replace(/([a-z])([A-Z])/g, `$1 $2`)}</span>
                            </div>
                            <div className={`${componentClass}__item__field__value`}>
                                {dateFields.indexOf(field.name) > -1 ||
                                dateFields.indexOf(field.type) > -1 ? (
                                    getDate(field.old_value)
                                ) : i18nFields.indexOf(field.name) < 0 ? (
                                    <div>
                                        <Markup content={field.old_value} />
                                    </div>
                                ) : (
                                    <div>
                                        {field.name === 'assignment' &&
                                            field.old_value
                                                .filter((a, i) => field.old_value.indexOf(a) === i)
                                                .map((value) => (
                                                    <div>
                                                        {intl.formatMessage({
                                                            id: i18nLabelMap[field.name](value),
                                                            defaultMessage: value,
                                                        })}
                                                    </div>
                                                ))}
                                        {field.name !== 'assignment' &&
                                            intl.formatMessage({
                                                id: i18nLabelMap[field.name]
                                                    ? i18nLabelMap[field.name](field.old_value)
                                                    : Array.isArray(field.old_value)
                                                    ? field.old_value[0]
                                                    : field.old_value,
                                                defaultMessage: Array.isArray(field.old_value)
                                                    ? field.old_value[0]
                                                    : field.old_value,
                                            })}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
            </div>
            <div className={`${componentClass}__content--new`}>
                <div className={`${componentClass}__item__title`}>
                    {intl.formatMessage({
                        id: `modals.new.activity.history.change.new`,
                        defaultMessage: 'New',
                    })}
                </div>
                {changeFields &&
                    changeFields.map((field) => (
                        <div className={`${componentClass}__item__field`} key={field.name}>
                            <div className={`${componentClass}__item__field__name`}>
                                {field.message && <span>{field.message}</span>}{' '}
                                <span>{field.name.replace(/([a-z])([A-Z])/g, `$1 $2`)}</span>
                            </div>
                            <div className={`${componentClass}__item__field__value`}>
                                {dateFields.indexOf(field.name) > -1 ||
                                dateFields.indexOf(field.type) > -1 ? (
                                    getDate(field.new_value)
                                ) : i18nFields.indexOf(field.name) < 0 ? (
                                    <div>
                                        <Markup content={field.new_value} />
                                    </div>
                                ) : (
                                    <div>
                                        {field.name === 'assignment' &&
                                            field.new_value
                                                .filter((a, i) => field.new_value.indexOf(a) === i)
                                                .map((value) => (
                                                    <div>
                                                        {intl.formatMessage({
                                                            id: i18nLabelMap[field.name](value),
                                                            defaultMessage: value,
                                                        })}
                                                    </div>
                                                ))}
                                        {field.name !== 'assignment' &&
                                            intl.formatMessage({
                                                id: i18nLabelMap[field.name]
                                                    ? i18nLabelMap[field.name](field.new_value)
                                                    : Array.isArray(field.new_value)
                                                    ? field.old_value[0]
                                                    : field.old_value,
                                                defaultMessage: field.new_value,
                                            })}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    recipientList: state[FILTERS_REDUCER_NAMESPACE].recipientList,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(HistoryChange)
